// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".errorContainer[data-v-67d5ba41]{position:absolute;top:64px;width:40%;left:30%;z-index:800000;box-shadow:0 1px 3px rgba(0,0,0,.12),0 -1px 5px rgba(0,0,0,.24)}.alert[data-v-67d5ba41]{margin:0}.notifContanier[data-v-67d5ba41]{position:absolute;bottom:60px;right:0;height:45px;z-index:800000;background-color:rgba(5,69,147,.708);box-shadow:0 1px 3px rgba(0,0,0,.12),0 -1px 5px rgba(0,0,0,.24);padding:10px;color:#fff}", ""]);
// Exports
module.exports = exports;
